import React from 'react'
import { motion } from 'framer-motion'

export default function ThankYou() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-emerald-50 to-teal-50 flex items-center justify-center p-4">
      <motion.div 
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
        className="max-w-2xl w-full bg-white rounded-3xl shadow-2xl p-8 md:p-12 text-center"
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
          className="text-8xl mb-6"
        >
          🎉
        </motion.div>

        <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
          Parabéns!
        </h1>

        <p className="text-xl text-gray-700 mb-8">
          Seu acesso foi liberado com sucesso!
        </p>

        <div className="bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-green-200 rounded-2xl p-6 mb-8">
          <p className="text-gray-700 mb-4">
            Você receberá um email com:
          </p>
          <ul className="text-left space-y-2 text-gray-700 max-w-md mx-auto">
            <li className="flex items-start gap-3">
              <span className="text-green-500">✓</span>
              <span>Link de acesso ao seu mapa personalizado</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-green-500">✓</span>
              <span>Credenciais de login</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-green-500">✓</span>
              <span>Instruções de como começar</span>
            </li>
          </ul>
        </div>

        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => window.location.href = 'https://exemplo.com/area-membros'}
          className="bg-gradient-to-r from-green-600 to-emerald-600 text-white text-xl font-bold py-4 px-12 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300"
        >
          ACESSAR MEU MAPA AGORA
        </motion.button>

        <p className="text-sm text-gray-500 mt-8">
          Não recebeu o email? Verifique sua caixa de spam ou entre em contato com nosso suporte.
        </p>
      </motion.div>
    </div>
  )
}
